module.exports = __webpack_public_path__ + "static/img/answerinput_Icon.6bbfbf1.svg";